<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'gestoesDeAulas' })"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Quadro de Horário da Gestão de Aula
          <!-- :{{ professor ? professor?.nome : "[NÃO INFORMADO]" }} -->
        </h1>

        <div v-if="gestoesDeAulas.length === 0" style="text-align: center">
          <v-alert color="warning" icon="fa fa-frown-o"
            >Nenhum Quadro de Horário disponível para este professor.</v-alert
          >
        </div>

        <v-simple-table v-else>
          <thead>
            <tr>
              <th style="text-align: center">Dia/Horário</th>
              <th v-for="horario in horariosUnicos" :key="horario.id" style="text-align: center">
                {{ horario.descricao }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(dia, index) in diasUnicos" :key="index">
              <td class="dia-coluna">
                <span class="dia-abreviado">{{ dia.descricao.slice(0, 3) }}</span>
                <span class="dia-completo">{{ dia.descricao }}</span>
              </td>
              <td
                v-for="(horario, i) in horariosUnicos"
                :key="`cell-${dia.id}-${horario.id}-${i}`"
                :class="{
                  'multiple-classes': getTodasTurmasDisciplinas(dia.id, horario.id).length > 1,
                  'has-content': getTodasTurmasDisciplinas(dia.id, horario.id).length > 0,
                }"
              >
                <div
                  v-for="(aula, idx) in getTodasTurmasDisciplinas(dia.id, horario.id)"
                  :key="`aula-${idx}`"
                  class="aula-item"
                  :style="{
                    backgroundColor: getCorPorDisciplina(aula.disciplina),
                  }"
                >
                  {{ aula.disciplina }}<br />
                  {{ aula.turma }}
                </div>
              </td>
            </tr>
          </tbody>
        </v-simple-table>

        <v-row class="no-print mt-3">
          <v-col class="text-right">
            <v-btn color="primary" @click="imprimirQuadro">
              <v-icon left>mdi-printer</v-icon>
              Imprimir Quadro
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </main-template>
</template>

<script>
export default {
  data() {
    return {
      professor: [],
      gestoesDeAulas: [],
      horariosUnicos: [],
      diasDaSemana: [
        { id: 1, descricao: "Segunda" },
        { id: 2, descricao: "Terça" },
        { id: 3, descricao: "Quarta" },
        { id: 4, descricao: "Quinta" },
        { id: 5, descricao: "Sexta" },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      try {
        this.$loaderService.open("Carregando Professor");
        const { gestaoDeAulaId } = this.$route.params;
        const response = await this.$services.gestoesDeAulasService.quadroHorario(gestaoDeAulaId);

        this.professor = response.professor || {};
        this.gestoesDeAulas = response;

        this.processarGestaoDeAulas();
        this.$loaderService.close();
      } catch (error) {
        this.$handleError(error);
      }
    },

    processarGestaoDeAulas() {
      const diasDaSemana = [
        { id: "Segunda-feira", descricao: "Segunda-feira", ordem: 1 },
        { id: "Terça-feira", descricao: "Terça-feira", ordem: 2 },
        { id: "Quarta-feira", descricao: "Quarta-feira", ordem: 3 },
        { id: "Quinta-feira", descricao: "Quinta-feira", ordem: 4 },
        { id: "Sexta-feira", descricao: "Sexta-feira", ordem: 5 },
        { id: "Sábado", descricao: "Sábado", ordem: 6 },
      ];

      const normalizarDia = (descricao) => {
        const diaDescricao = descricao.trim();

        const mapeamentoDias = {
          Segunda: "Segunda-feira",
          Terça: "Terça-feira",
          Quarta: "Quarta-feira",
          Quinta: "Quinta-feira",
          Sexta: "Sexta-feira",
        };

        return mapeamentoDias[diaDescricao] || diaDescricao;
      };

      const dias = new Map();
      const horarios = new Map();

      if (this.gestoesDeAulas.relacoesDiasHorarios) {
        this.gestoesDeAulas.relacoesDiasHorarios.forEach((relacao) => {
          const diaNormalizado = normalizarDia(relacao.dia.descricao);

          if (!dias.has(diaNormalizado)) {
            const diaConfig = diasDaSemana.find((d) => d.descricao === diaNormalizado);
            dias.set(diaNormalizado, {
              id: diaNormalizado,
              descricao: diaNormalizado,
              ordem: diaConfig ? diaConfig.ordem : 99,
            });
          }

          if (!horarios.has(relacao.horario.id)) {
            horarios.set(relacao.horario.id, {
              id: relacao.horario.id,
              descricao: relacao.horario.descricao,
            });
          }
        });
      }

      this.diasUnicos = Array.from(dias.values()).sort((a, b) => (a.ordem || 99) - (b.ordem || 99));
      this.horariosUnicos = Array.from(horarios.values()).sort((a, b) => a.id - b.id);
    },

    getTodasTurmasDisciplinas(diaId, horarioId) {
      if (!this.gestoesDeAulas || !this.gestoesDeAulas.relacoesDiasHorarios) return [];

      const normalizarDia = (descricao) => {
        const diaDescricao = descricao.trim();
        const mapeamentoDias = {
          Segunda: "Segunda-feira",
          Terça: "Terça-feira",
          Quarta: "Quarta-feira",
          Quinta: "Quinta-feira",
          Sexta: "Sexta-feira",
        };
        return mapeamentoDias[diaDescricao] || diaDescricao;
      };

      const relacoes = this.gestoesDeAulas.relacoesDiasHorarios.filter(
        (r) => normalizarDia(r.dia.descricao) === diaId && r.horario.id === horarioId
      );

      return relacoes.map(() => ({
        turma: this.gestoesDeAulas.turma?.descricao || "Turma não definida",
        disciplina: this.gestoesDeAulas.disciplina?.descricao || "Polivalência",
      }));
    },

    getTurmaDisciplina(diaId, horarioId) {
      if (!this.gestoesDeAulas || !this.gestoesDeAulas.relacoesDiasHorarios) return null;

      const relacao = this.gestoesDeAulas.relacoesDiasHorarios.find(
        (r) => r.dia.id === diaId && r.horario.id === horarioId
      );

      return relacao
        ? {
            turma: this.gestoesDeAulas.turma?.descricao || "Turma não definida",
            disciplina: this.gestoesDeAulas.disciplina?.descricao || "Polivalência",
          }
        : null;
    },

    getCorPorDisciplina(disciplina) {
      const corPorDisciplina = {
        Ciências: "#A2E4B8",
        "Língua Portuguesa": "#FFCC99",
        "Língua Inglesa": "#FFD6A5",
        Matemática: "#FDFFB6",
        História: "#99D1FF",
        Geografia: "#A0C4FF",
        Artes: "#B9FBC0",
        "Educação Física": "#98F5E1",
        "Ensino Religioso": "#E2D1F9",
        "Educação Infantil": "#FFC6FF",
        "Ensino Infantil": "#FFC6FF",
        Polivalência: "#E2E2E2",
      };

      const corEncontrada = Object.keys(corPorDisciplina).find((key) => disciplina.includes(key));

      return corEncontrada ? corPorDisciplina[corEncontrada] : "#ffffff";
    },

    async imprimirQuadro() {
      try {
        const { gestaoDeAulaId } = this.$route.params;
        this.$loaderService.open("Carregando dados...");
        await this.$services.gestoesDeAulasService.imprimirQuadroHorarioGestao(gestaoDeAulaId);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
  },
};
</script>

<style scoped>
th {
  text-align: center;
  background-color: #e0e0e0;
  padding: 10px;
}
td {
  text-align: center;
  padding: 0;
  border: 1px solid #ccc;
  vertical-align: middle;
}

td.has-content {
  border-right: 3px solid #999;
}

td.has-content:last-child {
  border-right: 1px solid #ccc;
}

td.has-content:not(.has-content) {
  border-right: 1px solid #ccc;
}

.multiple-classes {
  padding: 0 !important;
}

.aula-item {
  padding: 10px;
  border-bottom: 2px solid #fff;
  margin: 0;
  width: 100%;
  box-sizing: border-box;
  min-height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.aula-item:last-child {
  border-bottom: none;
}

td:not(.dia-coluna) {
  padding: 0 !important;
  height: 100%;
}

td:not(.dia-coluna):has(> div:only-child) {
  height: 100%;
}

td:not(.dia-coluna) > div:only-child {
  height: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.dia-completo {
  display: none;
}

.dia-abreviado {
  display: inline;
}

@media print {
  .dia-abreviado {
    display: none;
  }

  .dia-completo {
    display: inline;
  }

  .no-print {
    display: none !important;
  }
}
</style>
